import PageTitle from '@/components/PageTitle';
import { Flex } from 'antd';
import type { ReactNode } from 'react';
import { DASHBOARD_CRUMB } from './payroll.constants';

type Props = {
  /** Breadcrumbs after "Dashboard"; the last one is the current page. */
  crumbs: { title: ReactNode; path?: string }[];
  /** Toolbar on the right: search, filters, page actions. */
  children?: ReactNode;
};

/**
 * Title, breadcrumbs and toolbar of the pages a payroll batch opens into
 * (batch rows, bank list, encashment records), so they all line up the same.
 */
const PayrollPageHeader = ({ crumbs, children }: Props) => (
  <Flex align="center" justify="space-between" gap={16} wrap>
    <PageTitle title="Payroll" items={[DASHBOARD_CRUMB, ...crumbs]} />
    {children && (
      <Flex align="center" gap={16} wrap>
        {children}
      </Flex>
    )}
  </Flex>
);

export default PayrollPageHeader;
